import actionTypes from './actionTypes';

const initialState = {
  gameData: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.SET_RATE}_SUCCESS`: {
      return {
        ...state,
        gameData: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
